// eslint-disable-next-line
import React, { useEffect, useReducer } from 'react'

import { camelCase, get, transform } from 'lodash'

import { graphqlRequest } from '../graphql'

function reducer(state, newState) {
  return {
    ...state,
    ...newState,
  }
}

const initialState = {
  data: null,
  loading: false,
  error: null,
}

const formatVariables = (variables, defaultVariables) => {
  if (!variables || !defaultVariables) {
    throw new Error('You must provide variables and default variables to format them!')
  }
  if (typeof variables !== 'object' || typeof defaultVariables !== 'object') {
    throw new Error("Arguments 'variables' and 'defaultVariables' must be objects")
  }

  const formattedVariables = transform(variables, (result, value, snakeCasekey) => {
    const key = camelCase(snakeCasekey)
    if (defaultVariables[key]) {
      result[key] = { ...defaultVariables[key], ...{ value } }
    }
  })

  return formattedVariables
}

const defaultQueryOptions = {
  lazy: false,
}

export const useQuery = (operation, defaultVariables, options = defaultQueryOptions, fields) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  const getData = async newVariables => {
    const queryVariables = newVariables ? newVariables : defaultVariables
    try {
      dispatch({ loading: true, error: null })
      const response = await graphqlRequest(operation, queryVariables, fields)
      const data = get(response, operation)

      dispatch({ loading: false, data })
    } catch (error) {
      const message = error.message ? error.message : 'Something went wrong, please try again!'
      dispatch({ loading: false, error: message })
    }
  }

  const refetch = newVariables => {
    if (!newVariables) {
      getData()
      return
    }
    const formattedVariables = formatVariables(newVariables, defaultVariables)
    getData(formattedVariables)
  }

  useEffect(() => {
    if (!options.lazy) {
      getData()
    }
  }, [])

  const setData = newData => {
    dispatch({ data: newData })
  }

  return {
    data: state.data,
    refetch,
    loading: state.loading,
    error: state.error,
    setData,
  }
}



// WEBPACK FOOTER //
// ./src/utils/graphql/hooks/useQuery.js